import { Link } from "react-router-dom";
import { Calendar } from "lucide-react";

export default function ArticleCard({ article }) {
  const date = article.created_at
    ? new Date(article.created_at).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      })
    : "";

  return (
    <Link
      to={`/article/${article.slug}`}
      data-testid={`article-card-${article.slug}`}
      className="group block brut bg-white overflow-hidden brut-hover"
    >
      <div className="relative aspect-[16/10] overflow-hidden border-b-2 border-black">
        <img
          src={article.cover_image}
          alt={article.title}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-5">
        <div className="font-mono uppercase text-[10px] tracking-widest flex items-center gap-2 text-gray-700">
          <Calendar className="w-3 h-3" strokeWidth={2.5} />
          <span>{date}</span>
          <span className="opacity-50">·</span>
          <span>Article</span>
        </div>
        <h3 className="mt-2 font-display text-2xl leading-tight tracking-tight line-clamp-2">
          {article.title}
        </h3>
        <p className="mt-2 text-sm text-gray-700 line-clamp-3">
          {article.excerpt}
        </p>
        <div className="mt-3 inline-flex items-center font-mono uppercase text-[11px] tracking-widest pcs-text-pink">
          Read it →
        </div>
      </div>
    </Link>
  );
}
